"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearTransactions = exports.restoreTransactions = exports.storeTransactions = void 0;
const loader_1 = require("../loader");
const transactions = new Map();
function getKey(address, chainId) {
    return [loader_1.PersistedKeys.Transactions, address, chainId].join('.');
}
// TODO(#323): remove on v6, use radash replaceOrAppend instead https://radash-docs.vercel.app/docs/array-replace-or-append
function injectTransaction(transaction, transactions = []) {
    if (transactions.length === 0) {
        return [transaction];
    }
    let replaced = false;
    transactions = transactions.map((tx) => {
        if (tx.hash === transaction.hash) {
            replaced = true;
            return Object.assign(Object.assign({}, transaction), { chainId: typeof transaction.chainId === 'string'
                    ? parseInt(transaction.chainId, 16)
                    : transaction.chainId });
        }
        return tx;
    });
    return replaced ? transactions : [transaction, ...transactions];
}
function storeTransactions(address, chainId, txs) {
    const key = getKey(address, chainId);
    let memoryTransasctions = transactions.get(key) || [];
    let storageTransactions = JSON.parse(localStorage.getItem(key) || '[]');
    for (const tx of txs) {
        memoryTransasctions = injectTransaction(tx, memoryTransasctions);
        storageTransactions = injectTransaction(tx, storageTransactions);
    }
    const filteredMemoryTransasctions = memoryTransasctions.filter((tx) => tx.chainId === chainId);
    if (memoryTransasctions.length !== filteredMemoryTransasctions.length) {
        memoryTransasctions = filteredMemoryTransasctions;
    }
    transactions.set(key, memoryTransasctions);
    localStorage.setItem(key, JSON.stringify(storageTransactions));
    return memoryTransasctions;
}
exports.storeTransactions = storeTransactions;
function restoreTransactions(address, chainId) {
    const key = getKey(address, chainId);
    if (!transactions.has(key)) {
        const storedTransactions = JSON.parse(localStorage.getItem(key) || '[]');
        transactions.set(key, storedTransactions);
    }
    return transactions.get(key).filter((tx) => tx.chainId === chainId);
}
exports.restoreTransactions = restoreTransactions;
function clearTransactions(address, chainId) {
    const key = getKey(address, chainId);
    transactions.delete(key);
    localStorage.removeItem(key);
}
exports.clearTransactions = clearTransactions;
